export enum FocusBuildingPlanType {
  New = 'New',
  Expanding = 'Expanding'
}
